import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

describe('PartGroup', () => {
  describe('Index', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          m_parts: [
            {id: 1, name: "質問1_名称", description: "質問1_詳細", display_web_name: "質問1_表示名", description_web: null, m_company_id: 1, share_range_kbn: 1, is_return_question: false},
            {id: 2, name: "質問2_名称", description: "質問2_詳細", display_web_name: "質問2_表示名", description_web: null, m_company_id: 2, share_range_kbn: 0, is_return_question: false},
            {id: 3, name: "質問3_名称", description: "質問3_詳細", display_web_name: "質問3_表示名", description_web: null, m_company_id: 2, share_range_kbn: 0, is_return_question: true},
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index current_m_company_id={2}/>);

      await act(() => promise);

      // タイトル
      expect(screen.getByRole("heading", {name: "先確認質問一覧"})).toBeInTheDocument();

      // 検索エリア
      expect(screen.getByRole("columnheader", {name: "質問名"})).toBeInTheDocument();
      expect(screen.getByText('質問所有者')).toBeInTheDocument();
      expect(screen.getByRole("checkbox", {name: "自社質問"})).toBeInTheDocument();
      expect(screen.getByRole("checkbox", {name: "共通質問"})).toBeInTheDocument();
      expect(screen.getByRole("button", {name: "検索"})).toBeInTheDocument();

      // 注意書き文言
      expect(screen.getByRole("heading", {name: "管理者以外使用しないでください。 アンケートを表示するには店舗毎にアンケート表示設定をしてください。 ※ 新規追加・変更・コピー・削除を行うと、全店舗に反映されます。"})).toBeInTheDocument();

      // ボタン類
      expect(screen.getByText('質問登録')).toBeInTheDocument();

      // 表示エリア
      expect(screen.getByRole("row", {name: "質問名 説明 質問種類"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "質問1_名称 質問1_詳細 新患／再来向け プレビュー コピー"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "質問2_名称 質問2_詳細 新患／再来向け プレビュー コピー 編集 削除"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "質問3_名称 質問3_詳細 再来向け プレビュー コピー 編集 削除"})).toBeInTheDocument();
    });  
  }); 
});

